import React from 'react'
import { FilterPanel, ToggleChip } from '../../ui'

const STATUSES_BY_TAB = {
  open: [
    { value: 'TODO', label: 'Todo' },
    { value: 'IN_PROGRESS', label: 'In progress' },
  ],
  past: [
    { value: 'DONE', label: 'Done' },
    { value: 'CANCELLED', label: 'Cancelled' },
  ],
}

const PRIORITIES = [
  { value: 'HIGH', label: 'High' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'LOW', label: 'Low' },
  { value: 'NONE', label: 'None' },
]

function toggle(list, value) {
  const current = list ?? []
  const next = current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value]
  return next.length === 0 ? null : next
}

/**
 * Count the number of pressed chips across all three groups. Used by
 * the Tasks page header "Filters" button to render an active count
 * badge when the panel is collapsed.
 */
export function countActiveFilters(filters) {
  const statusCount = filters.statuses?.length ?? 0
  const priorityCount = filters.priorities?.length ?? 0
  const assigneeCount = filters.assignee?.length ?? 0
  return statusCount + priorityCount + assigneeCount
}

export function TasksFilters({
  tab,
  filters,
  onFiltersChange,
  isManager = false,
  open,
  panelId,
}) {
  const statusOptions = STATUSES_BY_TAB[tab] ?? STATUSES_BY_TAB.open
  const activeCount = countActiveFilters(filters)

  const isStatusActive = (value) => (filters.statuses ?? []).includes(value)
  const isPriorityActive = (value) => (filters.priorities ?? []).includes(value)
  const isAssigneeActive = (value) => (filters.assignee ?? []).includes(value)

  function clearAll() {
    onFiltersChange({ statuses: null, priorities: null, assignee: null })
  }

  return (
    <FilterPanel
      id={panelId}
      open={open}
      clearDisabled={activeCount === 0}
      onClearAll={clearAll}
    >
      <FilterPanel.Group label="Status">
        {statusOptions.map((opt) => (
          <ToggleChip
            key={opt.value}
            pressed={isStatusActive(opt.value)}
            onChange={() => onFiltersChange({ statuses: toggle(filters.statuses, opt.value) })}
          >
            {opt.label}
          </ToggleChip>
        ))}
      </FilterPanel.Group>
      <FilterPanel.Group label="Priority">
        {PRIORITIES.map((opt) => (
          <ToggleChip
            key={opt.value}
            pressed={isPriorityActive(opt.value)}
            onChange={() => onFiltersChange({ priorities: toggle(filters.priorities, opt.value) })}
          >
            {opt.label}
          </ToggleChip>
        ))}
      </FilterPanel.Group>
      <FilterPanel.Group label="Assignee">
        <ToggleChip
          pressed={isAssigneeActive('me')}
          onChange={() => onFiltersChange({ assignee: toggle(filters.assignee, 'me') })}
        >
          Me
        </ToggleChip>
        {isManager && (
          <ToggleChip
            pressed={isAssigneeActive('others')}
            onChange={() =>
              onFiltersChange({ assignee: toggle(filters.assignee, 'others') })
            }
          >
            Others
          </ToggleChip>
        )}
      </FilterPanel.Group>
    </FilterPanel>
  )
}
